export const initialState = {
  versetzungsplaene: [],
  hasDraftEinsaetze: false,
  abteilungen: undefined,
  isLoading: false,
  isLoadingAbteilungen: false,
  isLoadingTermine: false,
  isSaving: false,
  visibleAzubis: [],
  azubiIdsToLoadTermine: [],
}

export default function versetzungsplan(state = initialState) {
  return state
}
